export function nondisplayEdit(pic) {
	return {
    type: 'NONDISPLAY_EDIT',
		payload: {
			pic: pic,
		},
	}
};
